import './setupApp';
import { createBrowserHistory } from 'history';

import './locales/i18n';
import 'moment/dist/locale/de';
import 'moment/dist/locale/en-gb';
import 'moment/dist/locale/fr';

import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import { AuthProvider } from './contexts/SocketContext';

import track from './utils/analytics';
import reportWebVitals from './reportWebVitals';
import Providers from '@app/providers';

/**
 * Initialisation de l'application.
 */

// Auto-reload sur échec de chargement d'un chunk : si un déploiement a lieu
// pendant qu'une session est ouverte, les anciens chunks hashés sont supprimés
// et un `import()` retourne 404 (page cassée). Vite émet `vite:preloadError` ;
// on recharge pour récupérer index.html et ses hashs à jour. Le garde-temps
// (10 s) évite toute boucle de rechargement.
window.addEventListener('vite:preloadError', () => {
  try {
    const last = Number(sessionStorage.getItem('chunkReloadAt') || 0);
    if (Date.now() - last < 10000) {
      return;
    }
    sessionStorage.setItem('chunkReloadAt', String(Date.now()));
  } catch {
    // sessionStorage indisponible (Safari privé / WebView restreinte) : on recharge quand même.
  }
  window.location.reload();
});

const rootElem = document.getElementById('root');
const root = createRoot(rootElem);
const history = createBrowserHistory({ basename: window.env.PUBLIC_URL });

root.render(
  <Providers>
    <BrowserRouter
      history={history}
      basename={window.env.PUBLIC_URL}
      future={{
        v7_relativeSplatPath: true,
        v7_startTransition: true
      }}
    >
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </Providers>
);

// Initialize analytics and report web vitals if not running as an app
track.initialize();

if (!window.env.isApp) {
  reportWebVitals(track.vitals);
}
